import React from "react";

const DashboardContentFooter = ({ username, handleLogout }) => {
  return (
    <footer className="footer">
      <p>
        &copy; 2026 Developed by Reactive System Developers. Contact: 0257335982
      </p>
    </footer>
  );
};

export default DashboardContentFooter;
